import { DataMappingsApi } from '@/api/clients/data-mappings';
import { FacilitiesApi } from '@/api/clients/facilities';

export const CONDITION_TYPES = Object.freeze({
  MULTI_SELECT: 'multi-select',
  SELECT: 'select',
  TEXT: 'text',
});

const CONDITIONS_CONFIG = [
  {
    title: 'Data Mapping',
    field: 'refund_files.data_mapping_group_id',
    type: CONDITION_TYPES.MULTI_SELECT,
    operators: ['=', '!='],
    values: async () => {
      const res = await DataMappingsApi.getDataMappingsForFilters();
      return (res.data ?? []).map((dm) => ({ label: dm.name, value: dm.id }));
    },
  },

  {
    title: 'Facility',
    field: 'refunds.facility_id',
    type: CONDITION_TYPES.MULTI_SELECT,
    operators: ['=', '!='],
    values: async () => {
      const facilities = await FacilitiesApi.getFacilitiesForForms();
      return (facilities ?? []).map((f) => ({ label: f.name, value: f.id }));
    },
  },
];

export default CONDITIONS_CONFIG;
